import { z } from 'zod'

export const GetCompanyDocumentTypeSchema = z.object({
  alias: z.string(),
  title: z.string(),
})

export const GetCompanyDocumentMediaSchema = z.object({
  name: z.string(),
  size: z.coerce.number(),
})

export const GetCompanyDocumentInfoSchema = z.object({
  expired_at: z.coerce.date().nullish(),
  liability_type: z.enum(['employee', 'public']).nullish(),
  total_sum: z.string().nullish(),
})

export const GetCompanyDocumentSchema = z.object({
  created_at: z.coerce.date(),
  expired_at: z.coerce.date().nullish(),
  id: z.coerce.number(),
  upload_at: z.coerce.date().nullish(),
})

export type GetCompanyDocument = z.infer<typeof GetCompanyDocumentSchema>
export type GetCompanyDocumentType = z.infer<typeof GetCompanyDocumentTypeSchema>
